import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c6a057e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar-alt me-2" }),
  /*#__PURE__*/_createTextVNode("ปฏิทินการปฏิบัติราชการในภูมิภาค")
], -1))
const _hoisted_4 = { class: "card-subtitle text-muted" }
const _hoisted_5 = { class: "card-body my-3" }
const _hoisted_6 = { class: "ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullCalendar = _resolveComponent("FullCalendar")!
  const _component_ActivityFormComponent = _resolveComponent("ActivityFormComponent")!
  const _component_ActivityOffcanvasComponent = _resolveComponent("ActivityOffcanvasComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("h6", _hoisted_4, "จัดการตารางการปฏิบัติราชการในภูมิภาคของ " + _toDisplayString(_ctx.role?.name), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_FullCalendar, {
          options: {
          ..._ctx.calendarOptions,
          events: _ctx.fullCalendarEvents
        }
        }, {
          eventContent: _withCtx((arg) => [
            _createElementVNode("strong", null, _toDisplayString(arg.timeText), 1),
            _createElementVNode("em", _hoisted_6, _toDisplayString(arg.event.title), 1)
          ]),
          _: 1
        }, 8, ["options"])
      ])
    ]),
    _createVNode(_component_ActivityFormComponent, {
      ref: "activityForm",
      startDate: _ctx.startDate,
      endDate: _ctx.endDate,
      activityId: _ctx.selectedActivityId
    }, null, 8, ["startDate", "endDate", "activityId"]),
    _createVNode(_component_ActivityOffcanvasComponent, {
      ref: "activityOffcanvas",
      activityId: _ctx.selectedActivityId,
      onEdit: _ctx.editClick
    }, null, 8, ["activityId", "onEdit"])
  ], 64))
}